import { GroupVatModelType } from '@teinor/erp/types/company/vat/groupVat'
import { LittleModalCreateEdit } from '../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { valueOrDefaultValue } from '../../../../../../utils/globals/valueOrDefaultValue'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'


interface ModalCEGroupVatProps extends ModalEditComponentProps { }

const ModalCEGroupVat: React.FC<ModalCEGroupVatProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const fields: FormRender<GroupVatModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'PrestashopId',
                    label: t('prestashopId', 'Prestashop ID'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                    type: 'text',
                },
                {
                    name: 'WordpressId',
                    label: t('wordpressId', 'Wordpress ID'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                    type: 'text',
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ]
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/config/vat/updateGroupVat'} translations={{ title: t('editGroupVat', 'Editar grupo de impuestos'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/config/vat/createGroupVat'} translations={{
        title: t('createNewGroupVat', 'Crear nuevo grupo de impuestos'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCEGroupVat